import React from 'react';

import { Skeleton } from '@/components/ui/skeleton';

export const SkeletonProductCard = () => {
  // sm:min-w[220px] flex h-fit min-w-[170px]  cursor-pointer  snap-start flex-col border-none shadow-none md:h-[360px]  md:min-w-[240px] lg:h-[370px] xl:h-[392px] 2xl:min-w-[288px]
  return (
    <Skeleton className="sm:min-w[220px] group flex h-fit  min-w-[170px] cursor-pointer snap-start flex-col rounded-2xl border-none shadow-none md:min-w-[260px] 2xl:min-w-[280px]">
      <div className="relative flex h-[200px] w-full  items-center justify-center rounded-2xl md:h-[280px]">
        <Skeleton className="grid-2 row-span-3  h-5/6 w-full object-contain object-center" />

        <Skeleton className="absolute bottom-2 left-2 size-8  rounded-full border border-black-50  object-cover object-center md:size-12" />
      </div>
      <div className=" flex size-full flex-col justify-between">
        <Skeleton />
        <Skeleton />

        <Skeleton />
        <Skeleton />
      </div>
    </Skeleton>
  );
};

export function ProductSkeletonList(props: { count: number }) {
  return (
    <>
      {Array.from({ length: props.count }, (_, index) => (
        <SkeletonProductCard key={index.toString()} />
      ))}
    </>
  );
}
